import React, { useState, useEffect, useRef } from "react";
import { Input, Select, Switch } from "antd";
import styled from "styled-components";

// 全球撥號區碼清單：由 world-countries 套件資料 + opencc-js（cn -> twp）
// 轉換為繁體中文產生，並手動修正少數與台灣慣用譯名不同之處。
// 未做成 runtime 依賴是因為 world-countries／opencc-js 只在生成當下用一次，
// 兩者本身體積較大（分別約 750KB、6MB），對這種幾乎不會變動的靜態資料
// 沒有必要每次都在瀏覽器端載入完整套件；日後要更新可重新產生後貼回這裡。
const countryCodes = [
  { code: "+886", label: "台灣 (+886)", en: "Taiwan (+886)" },
  {
    code: "+1",
    label: "加拿大/多明尼加/波多黎各/美國 (+1)",
    en: "Canada/Dominican Republic/Puerto Rico/United States (+1)",
  },
  { code: "+7", label: "哈薩克/俄羅斯 (+7)", en: "Kazakhstan/Russia (+7)" },
  { code: "+20", label: "埃及 (+20)", en: "Egypt (+20)" },
  { code: "+27", label: "南非 (+27)", en: "South Africa (+27)" },
  { code: "+30", label: "希臘 (+30)", en: "Greece (+30)" },
  { code: "+31", label: "荷蘭 (+31)", en: "Netherlands (+31)" },
  { code: "+32", label: "比利時 (+32)", en: "Belgium (+32)" },
  { code: "+33", label: "法國 (+33)", en: "France (+33)" },
  { code: "+34", label: "西班牙 (+34)", en: "Spain (+34)" },
  { code: "+36", label: "匈牙利 (+36)", en: "Hungary (+36)" },
  { code: "+39", label: "義大利 (+39)", en: "Italy (+39)" },
  { code: "+40", label: "羅馬尼亞 (+40)", en: "Romania (+40)" },
  { code: "+41", label: "瑞士 (+41)", en: "Switzerland (+41)" },
  { code: "+43", label: "奧地利 (+43)", en: "Austria (+43)" },
  {
    code: "+44",
    label: "英國/根西島/馬恩島/澤西島 (+44)",
    en: "United Kingdom/Guernsey/Isle of Man/Jersey (+44)",
  },
  { code: "+45", label: "丹麥 (+45)", en: "Denmark (+45)" },
  { code: "+46", label: "瑞典 (+46)", en: "Sweden (+46)" },
  { code: "+47", label: "布維島/挪威 (+47)", en: "Bouvet Island/Norway (+47)" },
  { code: "+48", label: "波蘭 (+48)", en: "Poland (+48)" },
  { code: "+49", label: "德國 (+49)", en: "Germany (+49)" },
  { code: "+51", label: "秘魯 (+51)", en: "Peru (+51)" },
  { code: "+52", label: "墨西哥 (+52)", en: "Mexico (+52)" },
  { code: "+53", label: "古巴 (+53)", en: "Cuba (+53)" },
  { code: "+54", label: "阿根廷 (+54)", en: "Argentina (+54)" },
  { code: "+55", label: "巴西 (+55)", en: "Brazil (+55)" },
  { code: "+56", label: "智利 (+56)", en: "Chile (+56)" },
  { code: "+57", label: "哥倫比亞 (+57)", en: "Colombia (+57)" },
  { code: "+58", label: "委內瑞拉 (+58)", en: "Venezuela (+58)" },
  { code: "+60", label: "馬來西亞 (+60)", en: "Malaysia (+60)" },
  {
    code: "+61",
    label: "澳洲/科科斯/聖誕島 (+61)",
    en: "Australia/Cocos (Keeling) Islands/Christmas Island (+61)",
  },
  { code: "+62", label: "印尼 (+62)", en: "Indonesia (+62)" },
  { code: "+63", label: "菲律賓 (+63)", en: "Philippines (+63)" },
  {
    code: "+64",
    label: "紐西蘭/皮特凱恩群島 (+64)",
    en: "New Zealand/Pitcairn Islands (+64)",
  },
  { code: "+65", label: "新加坡 (+65)", en: "Singapore (+65)" },
  { code: "+66", label: "泰國 (+66)", en: "Thailand (+66)" },
  { code: "+81", label: "日本 (+81)", en: "Japan (+81)" },
  { code: "+82", label: "韓國 (+82)", en: "South Korea (+82)" },
  { code: "+84", label: "越南 (+84)", en: "Vietnam (+84)" },
  { code: "+86", label: "中國 (+86)", en: "China (+86)" },
  { code: "+90", label: "土耳其 (+90)", en: "Turkey (+90)" },
  { code: "+91", label: "印度 (+91)", en: "India (+91)" },
  { code: "+92", label: "巴基斯坦 (+92)", en: "Pakistan (+92)" },
  { code: "+93", label: "阿富汗 (+93)", en: "Afghanistan (+93)" },
  { code: "+94", label: "斯里蘭卡 (+94)", en: "Sri Lanka (+94)" },
  { code: "+95", label: "緬甸 (+95)", en: "Myanmar (+95)" },
  { code: "+98", label: "伊朗 (+98)", en: "Iran (+98)" },
  { code: "+211", label: "南蘇丹 (+211)", en: "South Sudan (+211)" },
  { code: "+212", label: "摩洛哥 (+212)", en: "Morocco (+212)" },
  { code: "+213", label: "阿爾及利亞 (+213)", en: "Algeria (+213)" },
  { code: "+216", label: "突尼西亞 (+216)", en: "Tunisia (+216)" },
  { code: "+218", label: "利比亞 (+218)", en: "Libya (+218)" },
  { code: "+220", label: "甘比亞 (+220)", en: "Gambia (+220)" },
  { code: "+221", label: "塞內加爾 (+221)", en: "Senegal (+221)" },
  { code: "+222", label: "茅利塔尼亞 (+222)", en: "Mauritania (+222)" },
  { code: "+223", label: "馬利 (+223)", en: "Mali (+223)" },
  { code: "+224", label: "幾內亞 (+224)", en: "Guinea (+224)" },
  { code: "+225", label: "象牙海岸 (+225)", en: "Ivory Coast (+225)" },
  { code: "+226", label: "布吉納法索 (+226)", en: "Burkina Faso (+226)" },
  { code: "+227", label: "尼日 (+227)", en: "Niger (+227)" },
  { code: "+228", label: "多哥 (+228)", en: "Togo (+228)" },
  { code: "+229", label: "貝南 (+229)", en: "Benin (+229)" },
  { code: "+230", label: "模里西斯 (+230)", en: "Mauritius (+230)" },
  { code: "+231", label: "賴比瑞亞 (+231)", en: "Liberia (+231)" },
  { code: "+232", label: "獅子山 (+232)", en: "Sierra Leone (+232)" },
  { code: "+233", label: "迦納 (+233)", en: "Ghana (+233)" },
  { code: "+234", label: "奈及利亞 (+234)", en: "Nigeria (+234)" },
  { code: "+235", label: "查德 (+235)", en: "Chad (+235)" },
  {
    code: "+236",
    label: "中非共和國 (+236)",
    en: "Central African Republic (+236)",
  },
  { code: "+237", label: "喀麥隆 (+237)", en: "Cameroon (+237)" },
  { code: "+238", label: "維德角 (+238)", en: "Cape Verde (+238)" },
  { code: "+239", label: "聖多美普林西比 (+239)", en: "São Tomé and Príncipe (+239)" },
  { code: "+240", label: "赤道幾內亞 (+240)", en: "Equatorial Guinea (+240)" },
  { code: "+241", label: "加彭 (+241)", en: "Gabon (+241)" },
  { code: "+242", label: "剛果共和國 (+242)", en: "Republic of the Congo (+242)" },
  {
    code: "+243",
    label: "剛果民主共和國 (+243)",
    en: "Democratic Republic of the Congo (+243)",
  },
  { code: "+244", label: "安哥拉 (+244)", en: "Angola (+244)" },
  { code: "+245", label: "幾內亞比索 (+245)", en: "Guinea-Bissau (+245)" },
  {
    code: "+246",
    label: "英屬印度洋領地 (+246)",
    en: "British Indian Ocean Territory (+246)",
  },
  { code: "+248", label: "塞席爾 (+248)", en: "Seychelles (+248)" },
  { code: "+249", label: "蘇丹 (+249)", en: "Sudan (+249)" },
  { code: "+250", label: "盧安達 (+250)", en: "Rwanda (+250)" },
  { code: "+251", label: "衣索比亞 (+251)", en: "Ethiopia (+251)" },
  { code: "+252", label: "索馬利亞 (+252)", en: "Somalia (+252)" },
  { code: "+253", label: "吉布提 (+253)", en: "Djibouti (+253)" },
  { code: "+254", label: "肯亞 (+254)", en: "Kenya (+254)" },
  { code: "+255", label: "坦尚尼亞 (+255)", en: "Tanzania (+255)" },
  { code: "+256", label: "烏干達 (+256)", en: "Uganda (+256)" },
  { code: "+257", label: "蒲隆地 (+257)", en: "Burundi (+257)" },
  { code: "+258", label: "莫三比克 (+258)", en: "Mozambique (+258)" },
  { code: "+260", label: "尚比亞 (+260)", en: "Zambia (+260)" },
  { code: "+261", label: "馬達加斯加 (+261)", en: "Madagascar (+261)" },
  {
    code: "+262",
    label: "法國南部和南極土地/馬約特/留尼旺島 (+262)",
    en: "French Southern and Antarctic Lands/Mayotte/Réunion (+262)",
  },
  { code: "+263", label: "辛巴威 (+263)", en: "Zimbabwe (+263)" },
  { code: "+264", label: "納米比亞 (+264)", en: "Namibia (+264)" },
  { code: "+265", label: "馬拉威 (+265)", en: "Malawi (+265)" },
  { code: "+266", label: "賴索托 (+266)", en: "Lesotho (+266)" },
  { code: "+267", label: "波札那 (+267)", en: "Botswana (+267)" },
  { code: "+268", label: "史瓦帝尼 (+268)", en: "Eswatini (+268)" },
  { code: "+269", label: "葛摩 (+269)", en: "Comoros (+269)" },
  { code: "+291", label: "厄利垂亞 (+291)", en: "Eritrea (+291)" },
  { code: "+297", label: "阿魯巴 (+297)", en: "Aruba (+297)" },
  { code: "+298", label: "法羅群島 (+298)", en: "Faroe Islands (+298)" },
  { code: "+299", label: "格陵蘭 (+299)", en: "Greenland (+299)" },
  { code: "+350", label: "直布羅陀 (+350)", en: "Gibraltar (+350)" },
  { code: "+351", label: "葡萄牙 (+351)", en: "Portugal (+351)" },
  { code: "+352", label: "盧森堡 (+352)", en: "Luxembourg (+352)" },
  { code: "+353", label: "愛爾蘭 (+353)", en: "Ireland (+353)" },
  { code: "+354", label: "冰島 (+354)", en: "Iceland (+354)" },
  { code: "+355", label: "阿爾巴尼亞 (+355)", en: "Albania (+355)" },
  { code: "+356", label: "馬爾他 (+356)", en: "Malta (+356)" },
  { code: "+357", label: "賽普勒斯 (+357)", en: "Cyprus (+357)" },
  { code: "+358", label: "芬蘭 (+358)", en: "Finland (+358)" },
  { code: "+359", label: "保加利亞 (+359)", en: "Bulgaria (+359)" },
  { code: "+370", label: "立陶宛 (+370)", en: "Lithuania (+370)" },
  { code: "+371", label: "拉脫維亞 (+371)", en: "Latvia (+371)" },
  { code: "+372", label: "愛沙尼亞 (+372)", en: "Estonia (+372)" },
  { code: "+373", label: "摩爾多瓦 (+373)", en: "Moldova (+373)" },
  { code: "+374", label: "亞美尼亞 (+374)", en: "Armenia (+374)" },
  { code: "+375", label: "白俄羅斯 (+375)", en: "Belarus (+375)" },
  { code: "+376", label: "安道爾 (+376)", en: "Andorra (+376)" },
  { code: "+377", label: "摩納哥 (+377)", en: "Monaco (+377)" },
  { code: "+378", label: "聖馬利諾 (+378)", en: "San Marino (+378)" },
  { code: "+380", label: "烏克蘭 (+380)", en: "Ukraine (+380)" },
  { code: "+381", label: "塞爾維亞 (+381)", en: "Serbia (+381)" },
  { code: "+382", label: "蒙特內哥羅 (+382)", en: "Montenegro (+382)" },
  { code: "+383", label: "科索沃 (+383)", en: "Kosovo (+383)" },
  { code: "+385", label: "克羅埃西亞 (+385)", en: "Croatia (+385)" },
  { code: "+386", label: "斯洛維尼亞 (+386)", en: "Slovenia (+386)" },
  {
    code: "+387",
    label: "波士尼亞與赫塞哥維納 (+387)",
    en: "Bosnia and Herzegovina (+387)",
  },
  { code: "+389", label: "北馬其頓 (+389)", en: "North Macedonia (+389)" },
  { code: "+420", label: "捷克 (+420)", en: "Czechia (+420)" },
  { code: "+421", label: "斯洛伐克 (+421)", en: "Slovakia (+421)" },
  { code: "+423", label: "列支敦斯登 (+423)", en: "Liechtenstein (+423)" },
  {
    code: "+500",
    label: "福克蘭群島/南喬治亞 (+500)",
    en: "Falkland Islands/South Georgia (+500)",
  },
  { code: "+501", label: "貝里斯 (+501)", en: "Belize (+501)" },
  { code: "+502", label: "瓜地馬拉 (+502)", en: "Guatemala (+502)" },
  { code: "+503", label: "薩爾瓦多 (+503)", en: "El Salvador (+503)" },
  { code: "+504", label: "宏都拉斯 (+504)", en: "Honduras (+504)" },
  { code: "+505", label: "尼加拉瓜 (+505)", en: "Nicaragua (+505)" },
  { code: "+506", label: "哥斯大黎加 (+506)", en: "Costa Rica (+506)" },
  { code: "+507", label: "巴拿馬 (+507)", en: "Panama (+507)" },
  {
    code: "+508",
    label: "聖皮埃爾和密克隆 (+508)",
    en: "Saint Pierre and Miquelon (+508)",
  },
  { code: "+509", label: "海地 (+509)", en: "Haiti (+509)" },
  {
    code: "+590",
    label: "聖巴泰勒米/瓜德羅普島/聖馬丁 (+590)",
    en: "Saint Barthélemy/Guadeloupe/Saint Martin (+590)",
  },
  { code: "+591", label: "玻利維亞 (+591)", en: "Bolivia (+591)" },
  { code: "+592", label: "蓋亞那 (+592)", en: "Guyana (+592)" },
  { code: "+593", label: "厄瓜多 (+593)", en: "Ecuador (+593)" },
  { code: "+594", label: "法屬蓋亞那 (+594)", en: "French Guiana (+594)" },
  { code: "+595", label: "巴拉圭 (+595)", en: "Paraguay (+595)" },
  { code: "+596", label: "馬提尼克 (+596)", en: "Martinique (+596)" },
  { code: "+597", label: "蘇利南 (+597)", en: "Suriname (+597)" },
  { code: "+598", label: "烏拉圭 (+598)", en: "Uruguay (+598)" },
  {
    code: "+599",
    label: "荷蘭加勒比區/庫拉索 (+599)",
    en: "Caribbean Netherlands/Curaçao (+599)",
  },
  { code: "+670", label: "東帝汶 (+670)", en: "Timor-Leste (+670)" },
  { code: "+672", label: "諾福克島 (+672)", en: "Norfolk Island (+672)" },
  { code: "+673", label: "汶萊 (+673)", en: "Brunei (+673)" },
  { code: "+674", label: "諾魯 (+674)", en: "Nauru (+674)" },
  { code: "+675", label: "巴布亞紐幾內亞 (+675)", en: "Papua New Guinea (+675)" },
  { code: "+676", label: "湯加 (+676)", en: "Tonga (+676)" },
  { code: "+677", label: "索羅門群島 (+677)", en: "Solomon Islands (+677)" },
  { code: "+678", label: "萬那杜 (+678)", en: "Vanuatu (+678)" },
  { code: "+679", label: "斐濟 (+679)", en: "Fiji (+679)" },
  { code: "+680", label: "帛琉 (+680)", en: "Palau (+680)" },
  { code: "+681", label: "瓦利斯和富圖納群島 (+681)", en: "Wallis and Futuna (+681)" },
  { code: "+682", label: "庫克群島 (+682)", en: "Cook Islands (+682)" },
  { code: "+683", label: "紐埃 (+683)", en: "Niue (+683)" },
  { code: "+685", label: "薩摩亞 (+685)", en: "Samoa (+685)" },
  { code: "+686", label: "吉里巴斯 (+686)", en: "Kiribati (+686)" },
  { code: "+687", label: "新喀里多尼亞 (+687)", en: "New Caledonia (+687)" },
  { code: "+688", label: "吐瓦魯 (+688)", en: "Tuvalu (+688)" },
  { code: "+689", label: "法屬波利尼西亞 (+689)", en: "French Polynesia (+689)" },
  { code: "+690", label: "托克勞 (+690)", en: "Tokelau (+690)" },
  { code: "+691", label: "密克羅尼西亞 (+691)", en: "Micronesia (+691)" },
  { code: "+692", label: "馬紹爾群島 (+692)", en: "Marshall Islands (+692)" },
  { code: "+850", label: "北韓 (+850)", en: "North Korea (+850)" },
  { code: "+852", label: "香港 (+852)", en: "Hong Kong (+852)" },
  { code: "+853", label: "澳門 (+853)", en: "Macau (+853)" },
  { code: "+855", label: "柬埔寨 (+855)", en: "Cambodia (+855)" },
  { code: "+856", label: "寮國 (+856)", en: "Laos (+856)" },
  { code: "+880", label: "孟加拉國 (+880)", en: "Bangladesh (+880)" },
  { code: "+960", label: "馬爾地夫 (+960)", en: "Maldives (+960)" },
  { code: "+961", label: "黎巴嫩 (+961)", en: "Lebanon (+961)" },
  { code: "+962", label: "約旦 (+962)", en: "Jordan (+962)" },
  { code: "+963", label: "敘利亞 (+963)", en: "Syria (+963)" },
  { code: "+964", label: "伊拉克 (+964)", en: "Iraq (+964)" },
  { code: "+965", label: "科威特 (+965)", en: "Kuwait (+965)" },
  { code: "+966", label: "沙烏地阿拉伯 (+966)", en: "Saudi Arabia (+966)" },
  { code: "+967", label: "葉門 (+967)", en: "Yemen (+967)" },
  { code: "+968", label: "阿曼 (+968)", en: "Oman (+968)" },
  { code: "+970", label: "巴勒斯坦 (+970)", en: "Palestine (+970)" },
  { code: "+971", label: "阿拉伯聯合大公國 (+971)", en: "United Arab Emirates (+971)" },
  { code: "+972", label: "以色列 (+972)", en: "Israel (+972)" },
  { code: "+973", label: "巴林 (+973)", en: "Bahrain (+973)" },
  { code: "+974", label: "卡達 (+974)", en: "Qatar (+974)" },
  { code: "+975", label: "不丹 (+975)", en: "Bhutan (+975)" },
  { code: "+976", label: "蒙古 (+976)", en: "Mongolia (+976)" },
  { code: "+977", label: "尼泊爾 (+977)", en: "Nepal (+977)" },
  { code: "+992", label: "塔吉克 (+992)", en: "Tajikistan (+992)" },
  { code: "+993", label: "土庫曼 (+993)", en: "Turkmenistan (+993)" },
  { code: "+994", label: "亞塞拜然 (+994)", en: "Azerbaijan (+994)" },
  { code: "+995", label: "喬治亞 (+995)", en: "Georgia (+995)" },
  { code: "+996", label: "吉爾吉斯斯坦 (+996)", en: "Kyrgyzstan (+996)" },
  { code: "+998", label: "烏茲別克 (+998)", en: "Uzbekistan (+998)" },
  { code: "+1242", label: "巴哈馬 (+1242)", en: "Bahamas (+1242)" },
  { code: "+1246", label: "巴貝多 (+1246)", en: "Barbados (+1246)" },
  { code: "+1264", label: "安圭拉 (+1264)", en: "Anguilla (+1264)" },
  {
    code: "+1268",
    label: "安地卡及巴布達 (+1268)",
    en: "Antigua and Barbuda (+1268)",
  },
  {
    code: "+1284",
    label: "英屬維爾京群島 (+1284)",
    en: "British Virgin Islands (+1284)",
  },
  {
    code: "+1340",
    label: "美屬維京群島 (+1340)",
    en: "United States Virgin Islands (+1340)",
  },
  { code: "+1345", label: "開曼群島 (+1345)", en: "Cayman Islands (+1345)" },
  { code: "+1441", label: "百慕大 (+1441)", en: "Bermuda (+1441)" },
  { code: "+1473", label: "格瑞那達 (+1473)", en: "Grenada (+1473)" },
  {
    code: "+1649",
    label: "特克斯和凱科斯群島 (+1649)",
    en: "Turks and Caicos Islands (+1649)",
  },
  { code: "+1664", label: "蒙特塞拉特 (+1664)", en: "Montserrat (+1664)" },
  {
    code: "+1670",
    label: "北馬利安納群島 (+1670)",
    en: "Northern Mariana Islands (+1670)",
  },
  { code: "+1671", label: "關島 (+1671)", en: "Guam (+1671)" },
  { code: "+1684", label: "美屬薩摩亞 (+1684)", en: "American Samoa (+1684)" },
  { code: "+1721", label: "聖馬丁島 (+1721)", en: "Sint Maarten (+1721)" },
  { code: "+1758", label: "聖露西亞 (+1758)", en: "Saint Lucia (+1758)" },
  { code: "+1767", label: "多米尼克 (+1767)", en: "Dominica (+1767)" },
  {
    code: "+1784",
    label: "聖文森及格瑞那丁 (+1784)",
    en: "Saint Vincent and the Grenadines (+1784)",
  },
  {
    code: "+1868",
    label: "千里達及托巴哥 (+1868)",
    en: "Trinidad and Tobago (+1868)",
  },
  {
    code: "+1869",
    label: "聖克里斯多福及尼維斯 (+1869)",
    en: "Saint Kitts and Nevis (+1869)",
  },
  { code: "+1876", label: "牙買加 (+1876)", en: "Jamaica (+1876)" },
  {
    code: "+4779",
    label: "斯瓦爾巴特 (+4779)",
    en: "Svalbard and Jan Mayen (+4779)",
  },
  { code: "+35818", label: "奧蘭群島 (+35818)", en: "Åland Islands (+35818)" },
];

// 部分國家的常見簡稱（搜尋用，不會顯示在選單上）
const searchAliases = {
  "+1": "USA US America",
  "+44": "UK GB Britain England",
  "+971": "UAE",
};

// 搜尋時忽略大小寫與重音符號（例如輸入 Reunion 可找到 Réunion）
const normalizeText = (text) =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

// 中英文名稱都納入搜尋，不論目前顯示哪一種語言
const countryOptions = countryCodes.map(({ code, label, en }) => ({
  value: code,
  zhLabel: label,
  enLabel: en,
  search: normalizeText(`${label} ${en} ${searchAliases[code] || ""}`),
}));

// 記住使用者是否偏好英文顯示，下次開啟（含其他頁面的電話欄位）沿用
const SHOW_ENGLISH_KEY = "phoneInputShowEnglish";

const readShowEnglish = () => {
  try {
    return localStorage.getItem(SHOW_ENGLISH_KEY) === "1";
  } catch (e) {
    return false;
  }
};

const saveShowEnglish = (value) => {
  try {
    localStorage.setItem(SHOW_ENGLISH_KEY, value ? "1" : "0");
  } catch (e) {
    // localStorage 不可用時僅不記住偏好，不影響功能
  }
};

const PhoneInputPlug = styled(Input)`
  :-internal-autofill-selected {
    background-color: green !important;
  }
`;

const PhoneInput = ({ value, onChange, placeholder, className, size }) => {
  const [countryCode, setCountryCode] = useState("+886");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showEnglish, setShowEnglish] = useState(readShowEnglish);
  const selectRef = useRef(null);
  // 記錄自己最後送出的值：Form 會把它原樣回填到 value，此時不需要再解析。
  // 否則像 +47 加上 79 開頭的號碼會被誤判成斯瓦爾巴特 (+4779)，
  // 造成下拉選單自己跳掉、已輸入的數字被吃進區碼。
  const lastEmittedRef = useRef(undefined);

  useEffect(() => {
    if (value === lastEmittedRef.current) return;
    // 走到這裡表示值是外部（載入資料、重設表單）改的，重新解析並清掉記錄
    lastEmittedRef.current = undefined;

    if (value) {
      // Try to parse existing value if it contains a country code
      let matchedCode = "+886";
      let matchedNumber = value;

      // Sort by length descending to match longer codes first (e.g. +886 before +8)
      const sortedCodes = [...countryCodes].sort(
        (a, b) => b.code.length - a.code.length,
      );

      for (const { code } of sortedCodes) {
        if (value.startsWith(code)) {
          matchedCode = code;
          matchedNumber = value.substring(code.length);
          break;
        }
      }

      setCountryCode(matchedCode);
      setPhoneNumber(matchedNumber);
    } else {
      setPhoneNumber("");
    }
  }, [value]);

  const handleCountryCodeChange = (code) => {
    setCountryCode(code);
    triggerChange(code, phoneNumber);
  };

  const handlePhoneChange = (e) => {
    let inputPhone = e.target.value;

    // Remove leading '0' if country code is '+886' and number starts with '0'
    if (countryCode === "+886" && inputPhone.startsWith("0")) {
      inputPhone = inputPhone.substring(1);
    }

    setPhoneNumber(inputPhone);
    triggerChange(countryCode, inputPhone);
  };

  const triggerChange = (code, phone) => {
    if (onChange) {
      if (!phone) {
        lastEmittedRef.current = "";
        onChange("");
        return;
      }

      let formattedPhone = phone;
      // Strip 0 again just to be safe if country code was just changed to +886
      if (code === "+886" && phone.startsWith("0")) {
        formattedPhone = phone.substring(1);
      }

      // Return the combined string, e.g., "+886912345678"
      const combined = `${code}${formattedPhone}`;
      lastEmittedRef.current = combined;
      onChange(combined);
    }
  };

  const handleShowEnglishChange = (checked) => {
    setShowEnglish(checked);
    saveShowEnglish(checked);
    // 點開關後焦點會停在開關上，還給搜尋框才能接著直接打字或用方向鍵選擇
    selectRef.current?.focus();
  };

  const selectBefore = (
    <Select
      ref={selectRef}
      value={countryCode}
      onChange={handleCountryCodeChange}
      className="bg-transparent"
      popupMatchSelectWidth={false}
      // 英文名稱較長（如 +1 合併多國），限制寬度避免手機上超出螢幕，超出的以省略號截斷
      dropdownStyle={{ maxWidth: 320 }}
      showSearch
      notFoundContent="查無符合的國家 No results"
      options={countryOptions.map(({ value, zhLabel, enLabel, search }) => ({
        value,
        label: showEnglish ? enLabel : zhLabel,
        search,
      }))}
      filterOption={(input, option) =>
        option.search.includes(normalizeText(input.trim()))
      }
      dropdownRender={(menu) => (
        <>
          <div className="flex items-center justify-between border-b border-gray-100 px-3 py-2">
            <span className="text-xs text-gray-500">英文顯示 English</span>
            <Switch
              size="small"
              checked={showEnglish}
              onChange={handleShowEnglishChange}
            />
          </div>
          {menu}
        </>
      )}
    />
  );

  return (
    <PhoneInputPlug
      size={size}
      className={className}
      addonBefore={selectBefore}
      value={phoneNumber}
      onChange={handlePhoneChange}
      placeholder={placeholder}
      type="tel"
    />
  );
};

export default PhoneInput;
